import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    FormControl,
    Select,
    MenuItem,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

type FundingType = "platform" | "vendor" | "hybrid";

export default function CreateTier({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    const [tierColor, setTierColor] = useState("#f59e0b");
    const [durationValue, setDurationValue] = useState<number>(1);
    const [durationUnit, setDurationUnit] =
        useState<"days" | "weeks" | "months">("months");

    /* 🔹 NEW: Tier-level Reward Funding */
    const [rewardFunding, setRewardFunding] =
        useState<FundingType>("platform");

    /* 🔹 NEW: Per-benefit funding */
    const [benefits, setBenefits] = useState([
        {
            name: "10% Discount",
            funding: "hybrid" as FundingType,
            platformShare: 5,
            vendorShare: 5,
            costCap: "",
        },
        {
            name: "Free Shipping",
            funding: "vendor" as FundingType,
            platformShare: 0,
            vendorShare: 100,
            costCap: "",
        },
    ]);

    const updateBenefit = (
        index: number,
        field: string,
        value: any
    ) => {
        const updated = [...benefits];
        updated[index] = { ...updated[index], [field]: value };
        setBenefits(updated);
    };

    const colors = [
        "#c2410c",
        "#a3a3a3",
        "#facc15",
        "#e5e7eb",
        "#93c5fd",
        "#2563eb",
        "#10b981",
        "#ef4444",
    ];

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Loyalty Tier</h2>
                        <button
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form">
                        <div className="gap_p">

                            {/* Tier Basics */}
                            <div className="control_group">
                                <label htmlFor="tier-name">Tier Name</label>
                                <TextField placeholder="e.g. Gold" fullWidth hiddenLabel inputProps={{ id: "tier-name" }} />
                            </div>

                            <div className="control_group">
                                <label htmlFor="tier-description">Description</label>
                                <TextField multiline rows={3} placeholder="Description" fullWidth hiddenLabel inputProps={{ id: "tier-description" }} />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="tier-min-points">Min Points</label>
                                <TextField type="number" fullWidth hiddenLabel placeholder="Enter" inputProps={{ id: "tier-min-points" }} />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="tier-min-spend">Min Spend (AED)</label>
                                <TextField type="number" fullWidth hiddenLabel placeholder="Enter" inputProps={{ id: "tier-min-spend" }} />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="tier-points-multiplier">Points Multiplier</label>
                                <TextField type="number" defaultValue={1} placeholder="Enter" fullWidth hiddenLabel inputProps={{ id: "tier-points-multiplier" }} />
                            </div>
                            <div className="control_group w_50">
                                <label htmlFor="tier-discount">Discount%</label>
                                <TextField type="number" defaultValue={1} placeholder="Enter" fullWidth hiddenLabel inputProps={{ id: "tier-discount" }} />
                            </div>

                            {/* Tier Color */}
                            {/* <div className="control_group">
                                <label>Tier Color</label>
                                <div className="color_picker">
                                    {colors.map((color) => (
                                        <span
                                            key={color}
                                            className={`color_dot ${tierColor === color ? "active" : ""
                                                }`}
                                            style={{ backgroundColor: color }}
                                            onClick={() => setTierColor(color)}
                                        />
                                    ))}
                                </div>
                            </div> */}

                            {/* 🔹 NEW: Reward Funding */}
                            <div className="control_group">
                                <label>Reward Funding (Tier Level)</label>
                                <RadioGroup
                                    row
                                    value={rewardFunding}
                                    onChange={(e) =>
                                        setRewardFunding(e.target.value as FundingType)
                                    }
                                >
                                    <FormControlLabel
                                        value="platform"
                                        control={<Radio />}
                                        label="Platform-funded"
                                    />
                                    <FormControlLabel
                                        value="vendor"
                                        control={<Radio />}
                                        label="Vendor-funded"
                                    />
                                    <FormControlLabel
                                        value="hybrid"
                                        control={<Radio />}
                                        label="Hybrid"
                                    />
                                </RadioGroup>
                            </div>

                            {/* 🔹 NEW: Per-Benefit Funding */}
                            <div className="benefit_section">
                                <h4>Per-Benefit Funding</h4>

                                {benefits.map((benefit, index) => (
                                    <div className="benefit_card  " key={index}>


                                        <div className="benefit_grid gap_p">
                                            <div className="control_group">
                                                <FormControl fullWidth>
                                                    <label htmlFor={`funding-source-${index}`}>Funding Source</label>
                                                    <Select
                                                        value={benefit.funding}
                                                        onChange={(e) =>
                                                            updateBenefit(
                                                                index,
                                                                "funding",
                                                                e.target.value
                                                            )
                                                        }
                                                        inputProps={{ id: `funding-source-${index}` }}
                                                    >
                                                        <MenuItem value="platform">
                                                            Platform-funded
                                                        </MenuItem>
                                                        <MenuItem value="vendor">
                                                            Vendor-funded
                                                        </MenuItem>
                                                        <MenuItem value="hybrid">
                                                            Hybrid
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            {benefit.funding === "hybrid" && (
                                                <>
                                                    <div className="control_group">
                                                        <TextField
                                                            hiddenLabel
                                                            label="Platform %"
                                                            type="number"
                                                            value={benefit.platformShare}
                                                            onChange={(e) =>
                                                                updateBenefit(
                                                                    index,
                                                                    "platformShare",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                    <div className="control_group">

                                                        <TextField
                                                            label="Vendor %"
                                                            type="number"
                                                            hiddenLabel
                                                            value={benefit.vendorShare}
                                                            onChange={(e) =>
                                                                updateBenefit(
                                                                    index,
                                                                    "vendorShare",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </>
                                            )}
                                            <div className="control_group">
                                                <TextField
                                                    label="Cost Cap (Optional)"
                                                    placeholder="AED per order"
                                                    hiddenLabel
                                                    value={benefit.costCap}
                                                    onChange={(e) =>
                                                        updateBenefit(
                                                            index,
                                                            "costCap",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Duration */}
                            < div className="control_group w_50" >
                                <label htmlFor="tier-duration">Tier Duration</label>
                                <TextField
                                    type="number"
                                    value={durationValue}
                                    onChange={(e) =>
                                        setDurationValue(Number(e.target.value))
                                    }
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "tier-duration" }}
                                />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="duration-unit">Duration Unit</label>
                                <Select
                                    fullWidth
                                    value={durationUnit}
                                    onChange={(e) =>
                                        setDurationUnit(
                                            e.target.value as "days" | "weeks" | "months"
                                        )
                                    }
                                    inputProps={{ id: "duration-unit" }}
                                >
                                    <MenuItem value="days">Days</MenuItem>
                                    <MenuItem value="weeks">Weeks</MenuItem>
                                    <MenuItem value="months">Months</MenuItem>
                                </Select>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button className="btn btn_primary">
                                Add Tier
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
